import React, { useEffect } from 'react'
import LoadingPageV2 from '../LoadingPageV2'
import { useLogout } from '../../hooks/useLogout'
import ROUTES from '../../consts/paths'
import { useNavigate } from 'react-router-dom'

const LogoutPage: React.FC = (): JSX.Element => {
  const { logOutUser } = useLogout()
  const navigate = useNavigate()

  useEffect(() => {
    const doLogout = async (): Promise<void> => {
      await logOutUser()
      navigate(ROUTES.LOGIN, { replace: true })
    }
    void doLogout()
  }, [logOutUser, navigate])

  return <LoadingPageV2 />
}

export default LogoutPage
